import React, { useState, useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import axios from "axios";
import PulseLoader from "react-spinners/PulseLoader";
import { AuthContext } from "../../context/AuthContext";
import { getDataWithToken } from "../../services/GetDataService";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate, useParams } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  form: {
    padding: "50px",
    background: "#fff",
    borderRadius: "10px",
    // textAlign: "center",
    width: "400px",
    boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
  },
  titleBox: {
    background: "#eaecf3",
    fontSize: "1.5rem",
    // fontWeight: 600,
    textAlign: "center",
    padding: "5px 20px",
    borderRadius: "8px",
    width: "fit-content",
    margin: "0px auto 30px",
    fontFamily: "'Roboto', sans-serif",
  },
}));

const UpdateSupportRequest = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  const [roleId, setRoleId] = useState("");
  const [reason, setReason] = useState("");
  const [reason_ar, setReason_ar] = useState("");
  const [reason_ku, setReason_ku] = useState("");
  const [position, setPosition] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [roleMessage, setRoleMessage] = useState("");
  const { fastpay_support_panel_user } = useContext(AuthContext);
  const [message, setMessage] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [status, setStatus] = useState("");

  const validation = () => {
    let isError = false;
    if (!reason.trim()) {
      handleSnakbarOpen("Please enter reason (English)", "error");
      document.getElementById("reason").focus();
      return (isError = true);
    }
    if (!reason_ar.trim()) {
      handleSnakbarOpen("Please enter reason (Arabic)", "error");
      document.getElementById("reason_ar").focus();
      return (isError = true);
    }
    if (!reason_ku.trim()) {
      handleSnakbarOpen("Please enter reason (Kurdish)", "error");
      document.getElementById("reason_ku").focus();
      return (isError = true);
    }
    if (!position) {
      handleSnakbarOpen("Please enter position no", "error");
      document.getElementById("position").focus();
      return (isError = true);
    }

    return isError;
  };

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let err = validation();

    if (err) {
      return;
    } else {
      setLoading(true);
      try {
        let data = {
          id,
          reason,
          reason_ar,
          reason_ku,
          position,
          status,
        };
        let response = await axios({
          url: "api/support-requests/update",
          method: "post",
          data: data,
          headers: {
            Authorization: `Bearer ${fastpay_support_panel_user.token}`,
          },
        });
        if (response.data.code === 200) {
          handleSnakbarOpen(response.data.messages.toString(), "success");
          setReason("");
          setReason_ar("");
          setReason_ku("");
          setPosition("");
          setStatus();
          navigate("/request-list");
        }
      } catch (error) {
        console.log("error", error);
        handleSnakbarOpen(error.response.data.messages.toString(), "error");
        if (error.response.data.messages.length < 1) {
          handleSnakbarOpen("Something went wrong", "error");
        }
        setLoading(false);
      }
      setLoading(false);
    }
  };

  const getData = async (pageNO, newUrl) => {
    setLoading2(true);
    let url;

    url = `api/support-requests/show?id=${id}`;

    let res = await getDataWithToken(url);

    if (res.data.code === 200) {
      setReason(res.data.data?.reason);
      setReason_ar(res.data.data?.reason_ar);
      setReason_ku(res.data.data?.reason_ku);
      setPosition(res.data.data?.position);
      setStatus(res.data.data?.status);
    } else {
      setMessage(res.data.messages.toString());
      if (res.data.messages.length < 1) {
        setMessage("Something went wrong");
      }
      setLoading2(false);
    }

    setLoading2(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <React.Fragment>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ height: "80vh" }}
      >
        <div className={classes.form}>
          <div className={classes.titleBox}>Update Support Request</div>
          <TextField
            id="reason"
            label="Enter Reason (English)"
            fullWidth
            size="small"
            variant="outlined"
            multiline
            rows={2}
            inputProps={{ maxLength: 255 }}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            sx={{ marginBottom: "30px" }}
          />

          <TextField
            id="reason_ar"
            label="Enter Reason (Arabic)"
            fullWidth
            size="small"
            variant="outlined"
            multiline
            rows={2}
            value={reason_ar}
            onChange={(e) => {
              const value = e.target.value;
              if (/^[\u0600-\u06FF\s]+$/.test(value) || value === "") {
                setReason_ar(value);
              }
            }}
            inputProps={{ dir: "rtl", lang: "ar",maxLength: 255 }}
            sx={{
              marginBottom: "30px",
              "& .MuiOutlinedInput-input": {
                // textAlign: "right",
              },
            }}
          />
          <TextField
            id="reason_ku"
            label="Enter Reason (Kurdish)"
            fullWidth
            size="small"
            variant="outlined"
            multiline
            rows={2}
            value={reason_ku}
            onChange={(e) => {
              const value = e.target.value;
              if (
                /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\s]+$/.test(value) ||
                value === ""
              ) {
                setReason_ku(value);
              }
            }}
            inputProps={{ dir: "rtl", lang: "ku",maxLength: 255 }}
            sx={{
              marginBottom: "30px",
              "& .MuiOutlinedInput-input": {
                textAlign: "right",
              },
            }}
          />
          <TextField
            id="position"
            type="number"
            label="Enter Position No"
            fullWidth
            size="small"
            variant="outlined"
            value={position}
            onKeyDown={(evt) =>
              ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
            }
            onChange={(e) => {
              setPosition(e.target.value);
            }}
            sx={{ marginBottom: "30px" }}
          />
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            sx={{ marginBottom: "30px" }}
          >
            <InputLabel id="demo-Status-outlined-label">Status</InputLabel>
            <Select
              labelId="demo-Status-outlined-label"
              id="demo-Status-outlined"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              label="Status"
            >
              <MenuItem value={1}>Active</MenuItem>
              <MenuItem value={0}>Inactive</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="contained"
            disableElevation
            fullWidth
            style={{ marginBottom: "30px" }}
            disabled={loading}
            onClick={onSubmit}
          >
            {loading === false && "Update"}
            <PulseLoader
              color={"#00848A"}
              loading={loading}
              size={10}
              speedMultiplier={0.5}
            />{" "}
          </Button>
        </div>
      </Grid>
    </React.Fragment>
  );
};

export default UpdateSupportRequest;
